import React from 'react';
import Section from '../Section';
import { BsArrowRight, BsStars } from 'react-icons/bs';

const servicesData = [
    {
        title: "Instant Video Consultation",
        subTitle: "Connect within 60 secs",
        imgUrl: "/images/medical/video_consulationnew.png",
        bgColor: "#c1def7",
        link: "https://app.gkcklinica.com/",
        tag: "24/7 Available",
        tagType: "hot"
    },
    {
        title: "Find Doctors Near You",
        subTitle: "Confirmed appointments",
        imgUrl: "/images/medical/find_doctorsnew.png",
        bgColor: "#abdada",
        link: "https://app.gkcklinica.com/",
        tag: "Verified",
        tagType: "safe"
    },
    {
        title: "Lab Tests",
        subTitle: "Home sample collection",
        imgUrl: "/images/medical/lab_testsnew.png",
        bgColor: "#d6dcfd",
        link: "https://app.gkcklinica.com/",
        tag: "OFFER -15%",
        tagType: "offer"
    },
    {
        title: "Surgeries",
        subTitle: "Trusted surgery centers",
        imgUrl: "/images/medical/surgeriesnew.png",
        bgColor: "#ced3d9",
        link: "https://app.gkcklinica.com/",
        tag: "Safe Care",
        tagType: "safe"
    },

];

export default function MedicalServices() {
    return (
        <Section topMd={100} bottomMd={100} className="cs_medical_services">
            <div className="container">
                {/* Section Header */}
                <div className="text-center mb-5">
                    <h2 className="dept-title mb-3">Our Specialized Healthcare Services</h2>
                    <p className="text-muted mx-auto col-lg-6">From instant consultations to home lab tests, we bring a complete clinical ecosystem to your fingertips.</p>
                </div>

                <div className="row g-4">
                    {servicesData.map((item, index) => (
                        <div className="col-xl-3 col-lg-4 col-md-6" key={index}>
                            <a href={item.link} className="cs_service_card_clinical">
                                {/* Visual Badge */}
                                {item.tag && (
                                    <span className={`cs_card_tag tag_${item.tagType}`}>
                                        {item.tagType === 'hot' && <BsStars className="me-1" />} {item.tag}
                                    </span>
                                )}

                                <div className="cs_card_img_wrap" style={{ backgroundColor: item.bgColor }}>
                                    <img src={item.imgUrl} alt={item.title} className="cs_card_img" />
                                </div>

                                <div className="cs_card_content">
                                    <div>
                                        <h3 className="cs_card_title">{item.title}</h3>
                                        <p className="cs_card_subtitle">{item.subTitle}</p>
                                    </div>
                                    <div className="cs_card_arrow">
                                        <BsArrowRight />
                                    </div>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </Section>
    );
}